export enum AuthenticationProviders {
  none = 0,
  local = 1,
  azureAd = 2,
  both = 3,
}

export const AuthenticationProviderNames = {
  0: [],
  1: ['Local user'],
  2: ['Active directory user'],
  3: ['Local user', 'Active directory user'],
};

export function getAuthProviderName(code: number): string[] {
  return AuthenticationProviderNames[code];
}

export function getAuthProviderNameAsString(code: number): string {
  return getAuthProviderName(code).join(', ');
}
